import { KNOWN_DEVICE_NUMS } from './constants.js';
export const POSITION_FRESHNESS_THRESHOLD_MINUTES = 30;
/** Âge numérique d'une capture. Les dates invalides ou futures ne sont pas fiables. */
export function positionAgeMs(capturedAt, now = Date.now()) {
    if (!capturedAt)
        return null;
    const timestamp = Date.parse(capturedAt);
    if (!Number.isFinite(timestamp) || timestamp > now)
        return null;
    return now - timestamp;
}
export function formatPositionAge(ageMs) {
    if (ageMs === null || !Number.isFinite(ageMs) || ageMs < 0)
        return '—';
    const totalMinutes = Math.floor(ageMs / 60_000);
    if (totalMinutes < 60)
        return `${totalMinutes} min`;
    const totalHours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (totalHours < 24)
        return minutes > 0 ? `${totalHours} h ${minutes} min` : `${totalHours} h`;
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    return hours > 0 ? `${days} j ${hours} h` : `${days} j`;
}
export function isKnownDevice(deviceNum) {
    return KNOWN_DEVICE_NUMS.includes(deviceNum);
}
export function deviceDisplayName(device) {
    return device.localMetadata?.localName?.trim() || device.name.trim() || device.deviceNum;
}
export function deviceAssignmentSummary(device) {
    const metadata = device.localMetadata;
    if (!metadata?.assignmentLabel)
        return null;
    if (metadata.assignmentType === 'person')
        return `Assigné à : ${metadata.assignmentLabel}`;
    if (metadata.assignmentType === 'vehicle')
        return `Véhicule : ${metadata.assignmentLabel}`;
    return null;
}
/** Fraîcheur de la position, indépendante du statut de connexion fournisseur. */
export function computePositionFreshness(lastUpdate, thresholdMinutes = POSITION_FRESHNESS_THRESHOLD_MINUTES) {
    const age = positionAgeMs(lastUpdate);
    if (age === null)
        return 'unknown';
    return age <= thresholdMinutes * 60_000 ? 'recent' : 'stale';
}
export function batteryLabel(battery) {
    return battery === null || battery === undefined ? '—' : `${Math.round(battery)} %`;
}
export function formatCoords(lat, lng, digits = 5) {
    if (lat === null || lng === null)
        return '—';
    return `${lat.toFixed(digits)}, ${lng.toFixed(digits)}`;
}
/** Distance approximative en mètres (Haversine). */
export function distanceMeters(a, b) {
    const R = 6_371_000;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(b.latitude - a.latitude);
    const dLng = toRad(b.longitude - a.longitude);
    const lat1 = toRad(a.latitude);
    const lat2 = toRad(b.latitude);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}
export function totalDistanceMeters(points) {
    let total = 0;
    for (let i = 1; i < points.length; i += 1) {
        const prev = points[i - 1];
        const cur = points[i];
        if (prev && cur)
            total += distanceMeters(prev, cur);
    }
    return total;
}
/** Position la plus récente d'un device sous forme de point, si disponible. */
export function deviceToPoint(device) {
    if (device.latitude === null || device.longitude === null || !device.lastUpdate)
        return null;
    return {
        deviceNum: device.deviceNum,
        latitude: device.latitude,
        longitude: device.longitude,
        accuracy: device.accuracy,
        battery: device.battery,
        locationType: device.locationType,
        timestamp: device.lastUpdate,
        address: null,
        speed: null,
        direction: null,
    };
}
//# sourceMappingURL=utils.js.map